module.exports = __webpack_public_path__ + "../static/img/panoptico_logo.e82df906.png";